import {CircularProgress, ModuleLevel} from "../../../../../index";
import React, {useState} from "react";
import {useViewerStore} from "../../../../../../store/store";
import {Flex, Select} from "antd";
import { SelectedBuildings } from "../../../../../../@types/types";

const IrradienceCharts = () => {
    const modeCircleSolar = useViewerStore(state => state.modeCircleSolar);
    const modeChartSolar = useViewerStore(state => state.modeChartSolar);
    const modeChartIrr = useViewerStore(state => state.modeChartIrr);

    const modeCount33Arr = useViewerStore(state => state.buildingWise33PercentRuleModuleCountList);

    const accessoryBuildingList = useViewerStore(state => state.accessoryBuildingList);

    const [selectedBuildings, setSelectedBuildings] = useState([]);
    const { Option } = Select;

    const buildingAttributesOptions = modeCount33Arr.filter(b => !accessoryBuildingList.includes(b.name)).map(
        b => ({
            label: 'Building ' + b.name,
            value: b.sizeSqFt,
            modules: b.modeCount,
            solarArrayArea: b.moduleArea * b.modeCount,
        })
    ).sort((a, b) => a.label.localeCompare(b.label)); // Sort by name

    const handleBuildingAttributesChange = (value: any) => {
        const selectedOptions: any = buildingAttributesOptions.filter(option => value.includes(option.value));
        setSelectedBuildings(selectedOptions);
    };

    const getFontSize = () => {
        return window.innerWidth < 1366 ? '11px' : '15px';
    };

    return (
        <div className={"tab-content-container"}>
            <div className={"tab-content-scrollable-container"}>
                <span className='popup__title' style={{marginTop: '0px'}}>Site Area Attributes</span>
                <div className='popup__column'>
                    <Flex>
                        <Flex
                            vertical
                            justify={'space-around'}
                            className={"irradiance-chart-tab-section-1"}
                        >
                            <Select
                                mode="multiple"
                                allowClear
                                placeholder="Select Building(s) to See Attributes..."
                                options={buildingAttributesOptions}
                                onChange={(value) => handleBuildingAttributesChange(value)}
                                style={{width: '200%', marginBottom: '6px'}}
                                showSearch={false}
                            />
                            {buildingAttributesOptions.map(option => (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '200%', textAlign: 'center', fontSize: getFontSize()}}>
                                <ul style={{ width: '50%'}}>
                                    {selectedBuildings.slice(0, Math.ceil(selectedBuildings.length / 2)).map((building: SelectedBuildings) => (
                                        <>
                                            <li>{building.label}</li>
                                            <li>Building Area: {Number(building.value).toFixed()} sq ft</li>
                                            <li>Modules Used: {building.modules}</li>
                                            <li>Solar Array Area: {Number(building.solarArrayArea).toFixed()} sq ft</li>
                                            <li>
                                                Array vs. Roof Area: {building.solarArrayArea === 0 || building.value === 0 
                                                    ? 0 
                                                    : Number((building.solarArrayArea / building.value) * 100).toFixed(2)}%
                                            </li>
                                            <br />
                                        </>
                                    ))}
                                </ul>
                                <ul style={{ width: '50%' }}>
                                    {selectedBuildings.slice(Math.ceil(selectedBuildings.length / 2)).map((building: SelectedBuildings) => (
                                        <>
                                            <li style={{ textAlign: 'center' }}>{building.label}</li>
                                            <li>Building Area: {Number(building.value).toFixed()} sq ft</li>
                                            <li>Modules Used: {building.modules}</li>
                                            <li>Solar Array Area: {Number(building.solarArrayArea).toFixed()} sq ft</li>
                                            <li>
                                                Array vs. Roof Area: {building.solarArrayArea === 0 || building.value === 0 
                                                    ? 0 
                                                    : Number((building.solarArrayArea / building.value) * 100).toFixed(2)}%
                                            </li>
                                            <br />
                                        </>
                                    ))}
                                </ul>
                            </div>
                        </Flex>
                    </Flex>
                </div>

                <span className='popup__title'>Monthly Irradiance and Solar Access</span>
                <div className='popup__column'>
                    <Flex justify='space-around'>
                        <ModuleLevel modeChartSolar={modeChartSolar} modeChartIrr={modeChartIrr}/>
                        <CircularProgress value={modeCircleSolar} label='Solar Access' pathColor='#f8ca8d'/>
                    </Flex>
                </div>
            </div>
        </div>
        )
}


export default IrradienceCharts;